import React from 'react';

export default function ViewToggle({ value, onChange, options }) {
  return (
    <div className="inline-flex bg-gray-100 rounded-full p-1">
      {options.map((opt) => {
        const active = value === opt.value;
        return (
          <button
            key={opt.value}
            onClick={() => onChange(opt.value)}
            className={`px-3 py-1 text-sm font-medium rounded-full transition-colors ${
              active ? 'bg-blue-600 text-white' : 'text-gray-700 hover:bg-gray-200'
            }`}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
} 